module.exports = __webpack_public_path__ + "img/Chuva.ed33b8bd.svg";